import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom"; // Next.js users: use next/link
import { safeString } from "../utils/langUtils";

import "swiper/css";
import "swiper/css/navigation";
// import { packagesData } from "../data/apartments/packagesData";
import { fetchPackages, likePackage  } from "../api/packages";
import { Heart, Plane, CheckCircle, Coffee, Sun, Utensils } from "lucide-react";


// Holiday Packages Feature Icons
const FEATURE_ICONS = {
  airport_pickup: {
    label: "Airport Pickup",
    Icon: Plane,
  },
  checkin: {
    label: "Check-in",
    Icon: CheckCircle,
  },
  evening_tea: {
    label: "Evening Tea",
    Icon: Coffee,
  },
  leisure: {
    label: "Leisure",
    Icon: Sun,
  },
  dinner_pickup: {
    label: "Dinner Pickup",
    Icon: Utensils,
  },
};


export default function PackagePage() {

    const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

//From mongoDB Data simulation
// useEffect(() => {
//     fetchPackages()
//       .then((data) => setPackages(data))
//       .catch(() => setPackages([]))
//       .finally(() => setLoading(false));
//   }, []);

// Locate this block starting at Line 48:
useEffect(() => {
    fetchPackages()
      .then((data) => {
        // ✅ ADD THIS NORMALIZATION BLOCK HERE:
        const cleanPackages = data.map((pkg) => ({
          ...pkg,
          title: safeString(pkg.title),
          description: safeString(pkg.description),
          duration: safeString(pkg.duration), 
        }));
        setPackages(cleanPackages);
        // ✅ END OF ADDED BLOCK
      })
      .catch((err) => {
        console.error("Failed to load packages", err);
        setPackages([]);
      })
      .finally(() => setLoading(false));
  }, []);
// End mongoDB simulation


//MongoDB wishlist simulation
useEffect(() => {
  let visitorId = localStorage.getItem("visitorId");
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem("visitorId", visitorId);
  }
}, []);
// End mongoDB simulation




      if (loading) return <div className="p-6">Loading packages...</div>;

  return (
    <div className="bg-white rounded-2xl shadow-sm p-6 space-y-6">
        <header className="flex items-center justify-between">
        <div>
            <h1 className="text-2xl font-bold text-slate-900">
            Holiday Packages
            </h1>
            <p className="text-slate-500 text-sm">
            Hand-picked experiences for your perfect getaway
            </p>
        </div>
        </header>


      <Swiper
        modules={[Navigation]}
            navigation={{
            prevEl: ".review-prev",
            nextEl: ".review-next",
            }}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >

        {packages.map((pkg) => (
          <SwiperSlide key={pkg.id || pkg._id || pkg.slug}>
            <Link
              to={`/packages/${pkg.slug}`} // 👉 SEO URL
              className="block"
            >
              <article className="relative h-[380px] rounded-2xl overflow-hidden group shadow-xl">
                {/* Image */}
                <img
                  src={pkg.image}
                  alt={pkg.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

                {/* Wishlist */}
                <button
                  onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    try {
                      const res = await likePackage(pkg.slug);

                      setPackages((prev) =>
                        prev.map((p) =>
                          p.slug === pkg.slug
                            ? { ...p, likesCount: res.data.likesCount }
                            : p
                        )
                      );
                    } catch (err) {
                      console.error("Like failed", err);
                    }
                  }}
                  className="absolute top-4 right-4 z-20 bg-white/90 backdrop-blur-md px-2.5 py-1.5 rounded-full flex items-center gap-1.5 shadow-md hover:bg-white transition"
                >
                  <span className="text-xs font-semibold text-slate-700">
                    {pkg.likesCount || 0}
                  </span>

                  <Heart
                    className={`w-4 h-4 transition ${
                      pkg.likesCount > 0
                        ? "text-red-500 fill-red-500"
                        : "text-slate-900"
                    }`}
                    strokeWidth={2}
                  />
                </button>


                {/* Content */}
                <div className="relative z-10 h-full flex flex-col justify-end p-5 text-white space-y-3">
                  <h2 className="text-xl font-bold">{pkg.title}</h2>

                  <div className="text-yellow-400 text-sm">★★★★★</div>

                  <p className="text-sm text-white">{pkg.duration}</p>

                      {/* INCLUDED FEATURES */}
                      {pkg.features?.length > 0 && (
                        <div className="grid grid-cols-5 gap-3 mt-2">
                          {pkg.features.map((key) => {
                            const feature = FEATURE_ICONS[key];
                            if (!feature) return null;

                            const { Icon, label } = feature;

                            return (
                              <div
                                key={key}
                                className="flex flex-col items-center gap-1.5"
                              >
                                {/* Icon container */}
                                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white/15 backdrop-blur-sm">
                                  <Icon className="w-4 h-4 text-white" />
                                </div>

                                {/* Label */}
                                <span className="text-[11px] font-medium text-white/90 text-center leading-tight">
                                  {label}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      )}

                  <p className="text-sm text-white/75 line-clamp-2">
                    {pkg.description}
                  </p>

                  <div className="flex justify-between items-center pt-4">
                    <span className="text-lg font-bold">
                      From ${pkg.price}
                    </span>
                    <span className="bg-white text-slate-900 px-5 py-2 rounded-xl text-sm font-semibold">
                      View Details
                    </span>
                  </div>
                </div>
              </article>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
